import { Injectable } from '@angular/core';
import { filterNilValue, QueryEntity } from '@datorama/akita';
import { map, withLatestFrom } from 'rxjs/operators';

import { AuthQuery } from '../auth';
import { RequestState, RequestStore } from './request.store';

@Injectable()
export class RequestQuery extends QueryEntity<RequestState> {
  pendingRequests$ = this.selectAll().pipe(
    filterNilValue(),
    withLatestFrom(this.authQuery.user$),
    map(([requests, user]) =>
      requests.filter(({ receiverIds }) => receiverIds.includes(user.id))
    )
  );

  userRequests$ = this.selectAll().pipe(
    withLatestFrom(this.authQuery.user$),
    map(([requests, user]) =>
      requests.filter(({ createdBy }) => createdBy.id === user.id)
    )
  );
  constructor(protected store: RequestStore, private authQuery: AuthQuery) {
    super(store);
  }
}
